import { graphql } from 'gql';

export const ratioCollectionGql = graphql(`
    query uerRatioCollection(
        $contractId: Long!
        $order: [RatioRowDataSortInput!]
        $skip: Int
        $take: Int
        $where: RatioRowDataFilterInput
    ) {
        uerRatioCollection(contractId: $contractId, order: $order, skip: $skip, take: $take, where: $where) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                code
                workConditions
                ratioType
                kozp
                knr
                ksp
                kem
                kmat
                ktz
                ktzzpm
                groupId
                groupName
                subGroupId
                subGroupName
            }
        }
    }
`);
